export const queryConfig = state => state.queryConfig;
export const voteInfo = state => state.voteInfo; // 投票信息
export const jwt = state => state.jwt;
export const orgid = state => state.orgid;
export const voteText = state => state.voteText;
export const activeTab = state => state.activeTab;

